<template>
  <main class="skills">

    <section class="sub-hero">
      <div class="hero-wrap">
        <div class="sub-hero-copy">
          <p class="tag" data-i18n="skills-sub-hero-eyebrow" v-html="$rt('skills-sub-hero-eyebrow')"></p>
          <h1 class="hero-title" data-i18n="skills-sub-hero-title" v-html="$rt('skills-sub-hero-title')"></h1>
          <p class="hero-desc" data-i18n="skills-sub-hero-desc" v-html="$rt('skills-sub-hero-desc')"></p>
          <div class="hero-actions">
            <a class="btn btn-primary btn-lg" href="https://ai-literacy.codepresso.io/" id="hero-diagnosis-cta">
              <span data-i18n="skills-sub-hero-cta" v-html="$rt('skills-sub-hero-cta')"></span>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </a>
          </div>
        </div>

        <ul class="hero-facts surface-glass">
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">

              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 17.21C14.2059 17.21 17.2101 14.2059 17.2101 10.5C17.2101 6.79422 14.2059 3.79004 10.5 3.79004C6.7942 3.79004 3.79004 6.79422 3.79004 10.5C3.79004 14.2059 6.7942 17.21 10.5 17.21Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                <path d="M10.5 4.5C12.0913 4.5 13.6174 5.13214 14.7426 6.25735C15.8678 7.38257 16.5 8.9087 16.5 10.5C16.5 12.0913 15.8678 13.6174 14.7426 14.7426C13.6174 15.8679 12.0913 16.5 10.5 16.5C8.9087 16.5 7.38257 15.8679 6.25735 14.7426C5.13214 13.6174 4.5 12.0913 4.5 10.5C4.5 8.9087 5.13214 7.38257 6.25735 6.25735C7.38257 5.13214 8.9087 4.5 10.5 4.5ZM10.5 2C8.24647 2.00265 6.08599 2.89904 4.49251 4.49252C2.89902 6.08601 2.00265 8.24647 2 10.5C2 11.6162 2.21985 12.7215 2.64702 13.7528C3.07418 14.7841 3.7003 15.7211 4.48959 16.5104C5.27889 17.2997 6.21592 17.9258 7.24719 18.353C8.27846 18.7801 9.38376 19 10.5 19C11.6166 19.0013 12.7225 18.7824 13.7544 18.3557C14.7862 17.929 15.7238 17.3029 16.5133 16.5133C17.3029 15.7238 17.929 14.7862 18.3557 13.7544C18.7824 12.7225 19.0013 11.6166 19 10.5C19 8.24566 18.1045 6.08365 16.5104 4.48959C14.9163 2.89553 12.7543 2 10.5 2Z" fill="var(--color-brand)"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4852 14.7068L21.8852 20.1168L20.1158 21.8829L14.7158 16.4729L16.4852 14.7068Z" fill="var(--color-brand)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value" data-i18n="skills-sub-hero-fact-value-01" v-html="$rt('skills-sub-hero-fact-value-01')"></div>
              <p class="metric-card__label text-label" data-i18n="skills-sub-hero-fact-label-01" v-html="$rt('skills-sub-hero-fact-label-01')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">

              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                <path d="M10.49 8H6.5C6.22386 8 6 8.22386 6 8.5V9.5C6 9.77614 6.22386 10 6.5 10H10.49C10.7661 10 10.99 9.77614 10.99 9.5V8.5C10.99 8.22386 10.7661 8 10.49 8Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 8.58579L17.293 6.29289L18.7072 7.70711L15.0001 11.4142L12.293 8.70711L13.7072 7.29289L15.0001 8.58579Z" fill="var(--color-brand)"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 14.5858L17.293 12.2929L18.7072 13.7071L15.0001 17.4142L12.293 14.7071L13.7072 13.2929L15.0001 14.5858Z" fill="var(--color-brand)"></path>
                <path d="M10.4998 14H6.50977C6.23362 14 6.00977 14.2239 6.00977 14.5V15.53C6.00977 15.8061 6.23362 16.03 6.50977 16.03H10.4998C10.7759 16.03 10.9998 15.8061 10.9998 15.53V14.5C10.9998 14.2239 10.7759 14 10.4998 14Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value" data-i18n="skills-sub-hero-fact-value-02" v-html="$rt('skills-sub-hero-fact-value-02')"></div>
              <p class="metric-card__label text-label" data-i18n="skills-sub-hero-fact-label-02" v-html="$rt('skills-sub-hero-fact-label-02')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">

              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 15H3C2.44772 15 2 15.4477 2 16V20C2 20.5523 2.44772 21 3 21H6C6.55228 21 7 20.5523 7 20V16C7 15.4477 6.55228 15 6 15Z" fill="var(--color-brand)"></path>
                <path d="M13 9H10C9.44772 9 9 9.44772 9 10V20C9 20.5523 9.44772 21 10 21H13C13.5523 21 14 20.5523 14 20V10C14 9.44772 13.5523 9 13 9Z" fill="var(--color-brand)"></path>
                <path d="M20 3H17C16.4477 3 16 3.44772 16 4V20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z" fill="var(--color-brand)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value" data-i18n="skills-sub-hero-fact-value-03" v-html="$rt('skills-sub-hero-fact-value-03')"></div>
              <p class="metric-card__label text-label" data-i18n="skills-sub-hero-fact-label-03" v-html="$rt('skills-sub-hero-fact-label-03')"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="process fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-process-eyebrow" v-html="$rt('skills-process-eyebrow')"></p>
          <h2 data-i18n="skills-process-title" v-html="$rt('skills-process-title')"></h2>
          <p class="desc" data-i18n="skills-process-desc" v-html="$rt('skills-process-desc')"></p>
        </div>
        <div class="section-content">
          <ol class="cycle">
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">

                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 17.21C14.2059 17.21 17.2101 14.2059 17.2101 10.5C17.2101 6.79422 14.2059 3.79004 10.5 3.79004C6.7942 3.79004 3.79004 6.79422 3.79004 10.5C3.79004 14.2059 6.7942 17.21 10.5 17.21Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path d="M10.5 4.5C12.0913 4.5 13.6174 5.13214 14.7426 6.25735C15.8678 7.38257 16.5 8.9087 16.5 10.5C16.5 12.0913 15.8678 13.6174 14.7426 14.7426C13.6174 15.8679 12.0913 16.5 10.5 16.5C8.9087 16.5 7.38257 15.8679 6.25735 14.7426C5.13214 13.6174 4.5 12.0913 4.5 10.5C4.5 8.9087 5.13214 7.38257 6.25735 6.25735C7.38257 5.13214 8.9087 4.5 10.5 4.5ZM10.5 2C8.24647 2.00265 6.08599 2.89904 4.49251 4.49252C2.89902 6.08601 2.00265 8.24647 2 10.5C2 11.6162 2.21985 12.7215 2.64702 13.7528C3.07418 14.7841 3.7003 15.7211 4.48959 16.5104C5.27889 17.2997 6.21592 17.9258 7.24719 18.353C8.27846 18.7801 9.38376 19 10.5 19C11.6166 19.0013 12.7225 18.7824 13.7544 18.3557C14.7862 17.929 15.7238 17.3029 16.5133 16.5133C17.3029 15.7238 17.929 14.7862 18.3557 13.7544C18.7824 12.7225 19.0013 11.6166 19 10.5C19 8.24566 18.1045 6.08365 16.5104 4.48959C14.9163 2.89553 12.7543 2 10.5 2Z" fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4852 14.7068L21.8852 20.1168L20.1158 21.8829L14.7158 16.4729L16.4852 14.7068Z" fill="currentColor"></path>
                </svg>
              </span>
              <h3 data-i18n="skills-process-item-title-01" v-html="$rt('skills-process-item-title-01')"></h3>
              <p class="description" data-i18n="skills-process-item-desc-01" v-html="$rt('skills-process-item-desc-01')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">

                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 16V7H13.25V16H10.75Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25 12.2598V16H3.75L3.75 11.5098C3.75 11.0458 3.9342 10.6006 4.26254 10.2723C4.59088 9.94397 5.03608 9.75977 5.5 9.75977H18.5C18.9641 9.75977 19.4092 9.94408 19.7374 10.2723C20.0655 10.6004 20.25 11.0455 20.25 11.5098V16H17.75V12.2598H6.25Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path d="M6.66667 16H3.33333C2.8731 16 2.5 16.3731 2.5 16.8333V20.1667C2.5 20.6269 2.8731 21 3.33333 21H6.66667C7.1269 21 7.5 20.6269 7.5 20.1667V16.8333C7.5 16.3731 7.1269 16 6.66667 16Z" fill="currentColor"></path>
                  <path d="M13.6667 16H10.3333C9.8731 16 9.5 16.3731 9.5 16.8333V20.1667C9.5 20.6269 9.8731 21 10.3333 21H13.6667C14.1269 21 14.5 20.6269 14.5 20.1667V16.8333C14.5 16.3731 14.1269 16 13.6667 16Z" fill="currentColor"></path>
                  <path d="M13.6667 2H10.3333C9.8731 2 9.5 2.3731 9.5 2.83333V6.16667C9.5 6.6269 9.8731 7 10.3333 7H13.6667C14.1269 7 14.5 6.6269 14.5 6.16667V2.83333C14.5 2.3731 14.1269 2 13.6667 2Z" fill="currentColor"></path>
                  <path d="M20.6667 16H17.3333C16.8731 16 16.5 16.3731 16.5 16.8333V20.1667C16.5 20.6269 16.8731 21 17.3333 21H20.6667C21.1269 21 21.5 20.6269 21.5 20.1667V16.8333C21.5 16.3731 21.1269 16 20.6667 16Z" fill="currentColor"></path>
                </svg>
              </span>
              <h3 data-i18n="skills-process-item-title-02" v-html="$rt('skills-process-item-title-02')"></h3>
              <p class="description" data-i18n="skills-process-item-desc-02" v-html="$rt('skills-process-item-desc-02')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-icon" aria-hidden="true">

                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path d="M10.49 8H6.5C6.22386 8 6 8.22386 6 8.5V9.5C6 9.77614 6.22386 10 6.5 10H10.49C10.7661 10 10.99 9.77614 10.99 9.5V8.5C10.99 8.22386 10.7661 8 10.49 8Z" fill="currentColor" fill-opacity="0.35"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 8.58579L17.293 6.29289L18.7072 7.70711L15.0001 11.4142L12.293 8.70711L13.7072 7.29289L15.0001 8.58579Z" fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 14.5858L17.293 12.2929L18.7072 13.7071L15.0001 17.4142L12.293 14.7071L13.7072 13.2929L15.0001 14.5858Z" fill="currentColor"></path>
                  <path d="M10.4998 14H6.50977C6.23362 14 6.00977 14.2239 6.00977 14.5V15.53C6.00977 15.8061 6.23362 16.03 6.50977 16.03H10.4998C10.7759 16.03 10.9998 15.8061 10.9998 15.53V14.5C10.9998 14.2239 10.7759 14 10.4998 14Z" fill="currentColor" fill-opacity="0.35"></path>
                </svg>
              </span>
              <h3 data-i18n="skills-process-item-title-03" v-html="$rt('skills-process-item-title-03')"></h3>
              <p class="description" data-i18n="skills-process-item-desc-03" v-html="$rt('skills-process-item-desc-03')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="is-return">
              <span class="cycle-icon" aria-hidden="true">

                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 15H3C2.44772 15 2 15.4477 2 16V20C2 20.5523 2.44772 21 3 21H6C6.55228 21 7 20.5523 7 20V16C7 15.4477 6.55228 15 6 15Z" fill="currentColor"></path>
                  <path d="M13 9H10C9.44772 9 9 9.44772 9 10V20C9 20.5523 9.44772 21 10 21H13C13.5523 21 14 20.5523 14 20V10C14 9.44772 13.5523 9 13 9Z" fill="currentColor"></path>
                  <path d="M20 3H17C16.4477 3 16 3.44772 16 4V20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z" fill="currentColor"></path>
                </svg>
              </span>
              <h3 data-i18n="skills-process-item-title-04" v-html="$rt('skills-process-item-title-04')"></h3>
              <p class="description" data-i18n="skills-process-item-desc-04" v-html="$rt('skills-process-item-desc-04')"></p>
            </li>
          </ol>
          <p class="cycle-note">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 12C4 7.58 7.58 4 12 4C14.5 4 16.73 5.15 18.2 6.95M20 12C20 16.42 16.42 20 12 20C9.5 20 7.27 18.85 5.8 17.05" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path><path d="M18 3.5V7.5H14M6 20.5V16.5H10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            <span data-i18n="skills-process-note" v-html="$rt('skills-process-note')"></span>
          </p>
        </div>
      </div>
    </section>

    <section class="features pain-section fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-features-eyebrow" v-html="$rt('skills-features-eyebrow')"></p>
          <h3 data-i18n="skills-features-title" v-html="$rt('skills-features-title')"></h3>
        </div>
        <div class="section-content">
          <ul class="pain-grid">
            <li class="pain-card pain-card--detail">
              <p class="pain-card__title" data-i18n="skills-features-item-subtitle-01" v-html="$rt('skills-features-item-subtitle-01')"></p>
              <p data-i18n="skills-features-item-desc-01" v-html="$rt('skills-features-item-desc-01')"></p>
            </li>

            <li class="pain-card pain-card--detail">
              <p class="pain-card__title" data-i18n="skills-features-item-subtitle-02" v-html="$rt('skills-features-item-subtitle-02')"></p>
              <p data-i18n="skills-features-item-desc-02" v-html="$rt('skills-features-item-desc-02')"></p>
            </li>

            <li class="pain-card pain-card--detail">
              <p class="pain-card__title" data-i18n="skills-features-item-subtitle-03" v-html="$rt('skills-features-item-subtitle-03')"></p>
              <p data-i18n="skills-features-item-desc-03" v-html="$rt('skills-features-item-desc-03')"></p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="catalog fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-catalog-eyebrow" v-html="$rt('skills-catalog-eyebrow')"></p>
          <h2 data-i18n="skills-catalog-title" v-html="$rt('skills-catalog-title')"></h2>
          <p class="desc" data-i18n="skills-catalog-desc" v-html="$rt('skills-catalog-desc')"></p>
        </div>
        <div class="section-content">
          <ul class="product-grid">
            <li>
              <div class="content-panel">
                <div class="content-panel__item">
                  <div class="content-panel__intro">
                    <div class="product-name">
                      <span class="icon-box tint" aria-hidden="true">
                        <img src="/images/icons/service/ic_aiFluent.svg" alt="">
                      </span>
                      <div>
                        <p class="mini-title-sm" data-i18n="skills-catalog-item-label-01" v-html="$rt('skills-catalog-item-label-01')"></p>
                        <h3>AI Fluent</h3>
                      </div>
                    </div>
                    <p class="product-desc" data-i18n="skills-catalog-item-desc-01" v-html="$rt('skills-catalog-item-desc-01')"></p>
                  </div>
                  <div class="content-panel__visual">
                    <img src="/images/products/aifluent/aifluent-sample.svg" alt="AI Fluent 전 직군 AI 활용 역량 진단 리포트 화면">
                    <ul class="product-points">
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-01-01" v-html="$rt('skills-catalog-item-point-01-01')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-01-02" v-html="$rt('skills-catalog-item-point-01-02')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-01-03" v-html="$rt('skills-catalog-item-point-01-03')"></span>
                      </li>
                    </ul>
                    <a class="link-arrow link-arrow-ink" href="/aifluent"><span data-i18n="skills-catalog-item-cta-01" v-html="$rt('skills-catalog-item-cta-01')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="content-panel">
                <div class="content-panel__item">
                  <div class="content-panel__intro">
                    <div class="product-name">
                      <span class="icon-box tint" aria-hidden="true">
                        <img src="/images/icons/service/ic_skillCertify.svg" alt="">
                      </span>
                      <div>
                        <p class="mini-title-sm" data-i18n="skills-catalog-item-label-02" v-html="$rt('skills-catalog-item-label-02')"></p>
                        <h3>SkillCertify</h3>
                      </div>
                    </div>
                    <p class="product-desc" data-i18n="skills-catalog-item-desc-02" v-html="$rt('skills-catalog-item-desc-02')"></p>
                  </div>
                  <div class="content-panel__visual">
                    <img src="/images/products/skillcertify/skillcertify-sample.svg" alt="SkillCertify 개발자 IT 실무 역량 평가 리포트 화면">
                    <ul class="product-points">
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-02-01" v-html="$rt('skills-catalog-item-point-02-01')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-02-02" v-html="$rt('skills-catalog-item-point-02-02')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-catalog-item-point-02-03" v-html="$rt('skills-catalog-item-point-02-03')"></span>
                      </li>
                    </ul>
                    <a class="link-arrow link-arrow-ink" href="/skillcertify"><span data-i18n="skills-catalog-item-cta-02" v-html="$rt('skills-catalog-item-cta-02')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="catalog-learn fade-up">
      <div class="section-wrap row is-sticky">
        <div class="section-aside">
          <div class="section-title text-left">
            <p class="mini-title" data-i18n="skills-catalog-learn-eyebrow" v-html="$rt('skills-catalog-learn-eyebrow')"></p>
            <h2 data-i18n="skills-catalog-learn-title" v-html="$rt('skills-catalog-learn-title')"></h2>
            <p class="desc" data-i18n="skills-catalog-learn-desc" v-html="$rt('skills-catalog-learn-desc')"></p>
          </div>

          <div class="learn-products">
            <p class="mini-title-sm" data-i18n="skills-catalog-learn-list-label" v-html="$rt('skills-catalog-learn-list-label')"></p>

            <ul class="choice-list">
              <li>
                <button class="choice-list__item" type="button" data-journey-program="0">
                  <span class="icon-box" aria-hidden="true">
                    <img src="/images/icons/service/ic_skillPath.svg" alt="">
                  </span>
                  <span class="choice-list__body">
                    <span class="choice-list__title">SkillPath</span>
                    <span class="text-caption" data-i18n="skills-catalog-learn-item-caption-01" v-html="$rt('skills-catalog-learn-item-caption-01')"></span>
                  </span>
                  <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
              </li>
              <li>
                <button class="choice-list__item" type="button" data-journey-program="1">
                  <span class="icon-box" aria-hidden="true">
                    <img src="/images/icons/service/ic_edu.svg" alt="">
                  </span>
                  <span class="choice-list__body">
                    <span class="choice-list__title">SkillCamp</span>
                    <span class="text-caption" data-i18n="skills-catalog-learn-item-caption-02" v-html="$rt('skills-catalog-learn-item-caption-02')"></span>
                  </span>
                  <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
              </li>
              <li>
                <button class="choice-list__item" type="button" data-journey-program="2">
                  <span class="icon-box" aria-hidden="true">
                    <img src="/images/icons/service/ic_skillFit.svg" alt="">
                  </span>
                  <span class="choice-list__body">
                    <span class="choice-list__title">SkillFit</span>
                    <span class="text-caption" data-i18n="skills-catalog-learn-item-caption-03" v-html="$rt('skills-catalog-learn-item-caption-03')"></span>
                  </span>
                  <svg class="choice-list__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </button>
              </li>
            </ul>
          </div>

          <a class="btn btn-primary" href="https://codepresso.io/home/contact">
            <span data-i18n="skills-catalog-learn-cta" v-html="$rt('skills-catalog-learn-cta')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>

        <div class="journey-stage" data-journey-stage="">
          <div class="journey-track" data-journey-track="">
            <div data-journey-track-step="0"></div>
            <div data-journey-track-step="1"></div>
            <div data-journey-track-step="2"></div>
          </div>

          <div class="content-panel journey-viewport surface-glass">
          <article class="content-panel__item journey-step is-active" id="learn-skillpath" data-journey-step="0">

            <div class="content-panel__intro">
              <div class="product-name">
                <span class="icon-box tint" aria-hidden="true">
                  <img src="/images/icons/service/ic_skillPath.svg" alt="">
                </span>
                <div>
                  <p class="mini-title-sm" data-i18n="skills-catalog-learn-step-label-01" v-html="$rt('skills-catalog-learn-step-label-01')"></p>
                  <h3 data-i18n="skills-catalog-learn-step-title-01" v-html="$rt('skills-catalog-learn-step-title-01')"></h3>
                </div>
              </div>
              <p class="product-desc" data-i18n="skills-catalog-learn-step-desc-01" v-html="$rt('skills-catalog-learn-step-desc-01')"></p>
            </div>

            <div class="content-panel__visual preview-frame preview-frame--flush learning-visual">
              <img src="/images/products/skillpath/skillpath-hero.svg" alt="분야별 트랙과 단계별 학습 경로를 보여주는 SkillPath 화면">
            </div>

            <ul class="product-points">
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-01-01" v-html="$rt('skills-catalog-learn-step-point-01-01')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-01-02" v-html="$rt('skills-catalog-learn-step-point-01-02')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-01-03" v-html="$rt('skills-catalog-learn-step-point-01-03')"></span>
              </li>
            </ul>
            <a class="link-arrow link-arrow-ink" href="/skillpath"><span data-i18n="skills-catalog-learn-step-cta-01" v-html="$rt('skills-catalog-learn-step-cta-01')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </article>

          <article class="content-panel__item journey-step" id="learn-skillcamp" data-journey-step="1">

            <div class="content-panel__intro">
              <div class="product-name">
                <span class="icon-box tint" aria-hidden="true">
                  <img src="/images/icons/service/ic_edu.svg" alt="">
                </span>
                <div>
                  <p class="mini-title-sm" data-i18n="skills-catalog-learn-step-label-02" v-html="$rt('skills-catalog-learn-step-label-02')"></p>
                  <h3 data-i18n="skills-catalog-learn-step-title-02" v-html="$rt('skills-catalog-learn-step-title-02')"></h3>
                </div>
              </div>
              <p class="product-desc" data-i18n="skills-catalog-learn-step-desc-02" v-html="$rt('skills-catalog-learn-step-desc-02')"></p>
            </div>

            <div class="content-panel__visual preview-frame preview-frame--flush learning-visual">
              <img src="/images/products/skillcamp-hero.svg" alt="사내 맞춤 집중 과정에서 팀 프로젝트와 전문가 피드백을 운영하는 SkillCamp 화면">
            </div>

            <ul class="product-points">
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-02-01" v-html="$rt('skills-catalog-learn-step-point-02-01')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-02-02" v-html="$rt('skills-catalog-learn-step-point-02-02')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-02-03" v-html="$rt('skills-catalog-learn-step-point-02-03')"></span>
              </li>
            </ul>
            <a class="link-arrow link-arrow-ink" href="/skillcamp"><span data-i18n="skills-catalog-learn-step-cta-02" v-html="$rt('skills-catalog-learn-step-cta-02')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </article>

          <article class="content-panel__item journey-step" id="learn-skillfit" data-journey-step="2">

            <div class="content-panel__intro">
              <div class="product-name">
                <span class="icon-box tint" aria-hidden="true">
                  <img src="/images/icons/service/ic_skillFit.svg" alt="">
                </span>
                <div>
                  <p class="mini-title-sm" data-i18n="skills-catalog-learn-step-label-03" v-html="$rt('skills-catalog-learn-step-label-03')"></p>
                  <h3 data-i18n="skills-catalog-learn-step-title-03" v-html="$rt('skills-catalog-learn-step-title-03')"></h3>
                </div>
              </div>
              <p class="product-desc" data-i18n="skills-catalog-learn-step-desc-03" v-html="$rt('skills-catalog-learn-step-desc-03')"></p>
            </div>

            <div class="content-panel__visual preview-frame preview-frame--flush learning-visual">
              <img src="/images/mockups/skillfit-hero-v1.svg" alt="AI 튜터와 1:1로 인터뷰하며 개인별 학습 경로를 설계하고 진단, 학습, 재진단을 순환하는 SkillFit 화면">
            </div>

            <ul class="product-points">
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-03-01" v-html="$rt('skills-catalog-learn-step-point-03-01')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-03-02" v-html="$rt('skills-catalog-learn-step-point-03-02')"></span>
              </li>
              <li>
                <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                <span data-i18n="skills-catalog-learn-step-point-03-03" v-html="$rt('skills-catalog-learn-step-point-03-03')"></span>
              </li>
            </ul>
            <a class="link-arrow link-arrow-ink" href="/skillfit"><span data-i18n="skills-catalog-learn-step-cta-03" v-html="$rt('skills-catalog-learn-step-cta-03')"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
          </article>
          </div>
        </div>
      </div>
    </section>

    <section class="blend fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-blend-eyebrow" v-html="$rt('skills-blend-eyebrow')"></p>
          <h2 data-i18n="skills-blend-title" v-html="$rt('skills-blend-title')"></h2>
          <p class="desc" data-i18n="skills-blend-desc" v-html="$rt('skills-blend-desc')"></p>
        </div>
        <div class="section-content">
          <ol class="blend-cycle">
            <li class="blend-step">
              <span class="feature-card-progress"><span class="feature-card-progress-bar"></span></span>

              <div class="blend-mock" aria-hidden="true">
                <div class="preview-frame preview-frame--flush blend-mock-screen" data-mock-motion="ticker">
                  <div class="preview-frame__bar">
                    <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                    <span class="blend-mock-url">assess.codepresso.io</span>
                  </div>
                  <div class="blend-mock-body">
                    <div class="blend-mock-head">
                      <span class="blend-mock-title" data-i18n="skills-blend-mock-01" v-html="$rt('skills-blend-mock-01')"></span>
                      <span class="journey-mock-badge is-live" data-i18n="skills-blend-mock-02" v-html="$rt('skills-blend-mock-02')"></span>
                    </div>
                    <div class="blend-mock-score">
                      <div class="blend-mock-gauge">
                        <svg viewBox="0 0 64 64" aria-hidden="true">
                          <circle cx="32" cy="32" r="28" fill="none" stroke="var(--color-brand-tint-2)" stroke-width="7"></circle>
                          <circle class="is-gauge" cx="32" cy="32" r="28" fill="none" stroke="var(--color-brand)" stroke-width="7" stroke-linecap="round" stroke-dasharray="176" stroke-dashoffset="82" style="--mock-gauge-from: 176; --mock-gauge-to: 82"></circle>
                        </svg>
                        <b class="is-pop">53<em data-i18n="skills-blend-mock-03" v-html="$rt('skills-blend-mock-03')"></em></b>
                      </div>
                      <ul class="blend-mock-legend">
                        <li data-i18n="skills-blend-mock-04" v-html="$rt('skills-blend-mock-04')"></li>
                        <li data-i18n="skills-blend-mock-05" v-html="$rt('skills-blend-mock-05')"></li>
                        <li class="is-focus" data-i18n="skills-blend-mock-06" v-html="$rt('skills-blend-mock-06')"></li>
                      </ul>
                    </div>
                    <ul class="blend-mock-bars">
                      <li><i class="is-bar" style="--mock-bar-h: 64%"></i><span data-i18n="skills-blend-mock-07" v-html="$rt('skills-blend-mock-07')"></span></li>
                      <li><i class="is-bar" style="--mock-bar-h: 38%"></i><span data-i18n="skills-blend-mock-08" v-html="$rt('skills-blend-mock-08')"></span></li>
                      <li><i class="is-bar" style="--mock-bar-h: 26%"></i><span>AI</span></li>
                      <li><i class="is-bar" style="--mock-bar-h: 52%"></i><span data-i18n="skills-blend-mock-09" v-html="$rt('skills-blend-mock-09')"></span></li>
                      <li><i class="is-bar" style="--mock-bar-h: 44%"></i><span data-i18n="skills-blend-mock-10" v-html="$rt('skills-blend-mock-10')"></span></li>
                    </ul>
                    <div class="blend-mock-row is-feed">
                      <span class="journey-mock-avatar" data-i18n="skills-blend-mock-11" v-html="$rt('skills-blend-mock-11')"></span>
                      <span class="blend-mock-row-name" data-i18n="skills-blend-mock-12" v-html="$rt('skills-blend-mock-12')"></span>
                      <span class="blend-mock-row-meta" data-i18n="skills-blend-mock-13" v-html="$rt('skills-blend-mock-13')"></span>
                    </div>
                  </div>
                </div>
              </div>
              <span class="mini-title-sm" data-i18n="skills-blend-step-tag-01" v-html="$rt('skills-blend-step-tag-01')"></span>
              <h3 data-i18n="skills-blend-step-title-01" v-html="$rt('skills-blend-step-title-01')"></h3>
              <p class="desc-sm" data-i18n="skills-blend-step-desc-01" v-html="$rt('skills-blend-step-desc-01')"></p>
            </li>
            <li class="blend-step">
              <span class="feature-card-progress"><span class="feature-card-progress-bar"></span></span>

              <div class="blend-mock" aria-hidden="true">
                <div class="preview-frame preview-frame--flush blend-mock-screen" data-mock-motion="detail">
                  <div class="preview-frame__bar">
                    <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                    <span class="blend-mock-url">design.codepresso.io</span>
                  </div>
                  <div class="blend-mock-split">
                    <div class="blend-mock-aside">
                      <span class="blend-mock-aside-label" data-i18n="skills-blend-mock-14" v-html="$rt('skills-blend-mock-14')"></span>
                      <ul class="blend-mock-combo">
                        <li class="is-selected"><span class="journey-mock-check is-done"></span>SkillPath<em data-i18n="skills-blend-mock-15" v-html="$rt('skills-blend-mock-15')"></em></li>
                        <li class="is-selected" style="animation-delay: .1s"><span class="journey-mock-check is-done"></span>SkillCamp<em data-i18n="skills-blend-mock-16" v-html="$rt('skills-blend-mock-16')"></em></li>
                        <li class="is-selected" style="animation-delay: .2s"><span class="journey-mock-check is-done"></span>SkillFit<em data-i18n="skills-blend-mock-17" v-html="$rt('skills-blend-mock-17')"></em></li>
                        <li class="is-quiet"><span class="journey-mock-check"></span><span class="skeleton-line is-shimmer" style="width: 54px"></span></li>
                      </ul>
                    </div>
                    <div class="blend-mock-panel is-panel">
                      <div class="blend-mock-head">
                        <span class="blend-mock-title" data-i18n="skills-blend-mock-18" v-html="$rt('skills-blend-mock-18')"></span>
                        <span class="journey-mock-badge" data-i18n="skills-blend-mock-19" v-html="$rt('skills-blend-mock-19')"></span>
                      </div>
                      <ul class="blend-mock-plan">
                        <li class="is-stagger">
                          <span class="blend-mock-week" data-i18n="skills-blend-mock-20" v-html="$rt('skills-blend-mock-20')"></span>
                          <span class="blend-mock-track">SkillPath</span>
                          <i style="--blend-track-w: 34%"></i>
                        </li>
                        <li class="is-stagger" style="animation-delay: .12s">
                          <span class="blend-mock-week" data-i18n="skills-blend-mock-21" v-html="$rt('skills-blend-mock-21')"></span>
                          <span class="blend-mock-track is-camp">SkillCamp</span>
                          <i class="is-camp" style="--blend-track-w: 30%; --blend-track-x: 34%"></i>
                        </li>
                        <li class="is-stagger" style="animation-delay: .24s">
                          <span class="blend-mock-week" data-i18n="skills-blend-mock-22" v-html="$rt('skills-blend-mock-22')"></span>
                          <span class="blend-mock-track is-fit">SkillFit</span>
                          <i class="is-fit" style="--blend-track-w: 36%; --blend-track-x: 64%"></i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <span class="mini-title-sm" data-i18n="skills-blend-step-tag-02" v-html="$rt('skills-blend-step-tag-02')"></span>
              <h3 data-i18n="skills-blend-step-title-02" v-html="$rt('skills-blend-step-title-02')"></h3>
              <p class="desc-sm" data-i18n="skills-blend-step-desc-02" v-html="$rt('skills-blend-step-desc-02')"></p>
            </li>
            <li class="blend-step">
              <span class="feature-card-progress"><span class="feature-card-progress-bar"></span></span>

              <div class="blend-mock" aria-hidden="true">
                <div class="preview-frame preview-frame--flush blend-mock-screen" data-mock-motion="ticker">
                  <div class="preview-frame__bar">
                    <span class="preview-frame__dots"><i></i><i></i><i></i></span>
                    <span class="blend-mock-url">report.codepresso.io</span>
                  </div>
                  <div class="blend-mock-body">
                    <div class="blend-mock-head">
                      <span class="blend-mock-title" data-i18n="skills-blend-mock-23" v-html="$rt('skills-blend-mock-23')"></span>
                      <span class="journey-mock-badge" data-i18n="skills-blend-mock-24" v-html="$rt('skills-blend-mock-24')"></span>
                    </div>
                    <div class="blend-mock-compare">
                      <div class="blend-mock-compare-col">
                        <span class="blend-mock-compare-label" data-i18n="skills-blend-mock-25" v-html="$rt('skills-blend-mock-25')"></span>
                        <i class="is-bar" style="--mock-bar-h: 42%"></i>
                        <b>53</b>
                      </div>
                      <div class="blend-mock-delta">
                        <span class="blend-mock-delta-value is-pop">+33</span>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                      </div>
                      <div class="blend-mock-compare-col is-after">
                        <span class="blend-mock-compare-label" data-i18n="skills-blend-mock-26" v-html="$rt('skills-blend-mock-26')"></span>
                        <i class="is-bar" style="--mock-bar-h: 86%"></i>
                        <b>86</b>
                      </div>
                    </div>
                    <ul class="blend-mock-delta-list">
                      <li>
                        <span class="blend-mock-row-name" data-i18n="skills-blend-mock-27" v-html="$rt('skills-blend-mock-27')"></span>
                        <span class="blend-mock-meter"><i style="--blend-track-w: 88%"></i></span>
                        <span class="blend-mock-up">+29</span>
                      </li>
                      <li>
                        <span class="blend-mock-row-name" data-i18n="skills-blend-mock-28" v-html="$rt('skills-blend-mock-28')"></span>
                        <span class="blend-mock-meter"><i style="--blend-track-w: 74%"></i></span>
                        <span class="blend-mock-up">+35</span>
                      </li>

                      <li class="is-focus">
                        <span class="blend-mock-row-name" data-i18n="skills-blend-mock-29" v-html="$rt('skills-blend-mock-29')"></span>
                        <span class="blend-mock-meter"><i style="--blend-track-w: 88%"></i></span>
                        <span class="blend-mock-up">+41</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <span class="mini-title-sm" data-i18n="skills-blend-step-tag-03" v-html="$rt('skills-blend-step-tag-03')"></span>
              <h3 data-i18n="skills-blend-step-title-03" v-html="$rt('skills-blend-step-title-03')"></h3>
              <p class="desc-sm" data-i18n="skills-blend-step-desc-03" v-html="$rt('skills-blend-step-desc-03')"></p>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <section class="features-analyze fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-analyze-eyebrow" v-html="$rt('skills-analyze-eyebrow')"></p>
          <h2 data-i18n="skills-analyze-title" v-html="$rt('skills-analyze-title')"></h2>
          <p class="desc" data-i18n="skills-analyze-desc" v-html="$rt('skills-analyze-desc')"></p>
        </div>
        <div class="section-content">
          <ul class="analyze-grid">
            <li>
              <div class="content-panel is-primary">
                <div class="content-panel__item">
                  <div class="content-panel__intro">
                    <p class="mini-title-sm" data-i18n="skills-analyze-item-label-01" v-html="$rt('skills-analyze-item-label-01')"></p>
                    <h3 data-i18n="skills-analyze-item-title-01" v-html="$rt('skills-analyze-item-title-01')"></h3>
                    <p class="desc-sm" data-i18n="skills-analyze-item-desc-01" v-html="$rt('skills-analyze-item-desc-01')"></p>
                  </div>
                  <div class="content-panel__visual">

                    <div class="organization-dashboard-visual">
                      <img src="/images/mockups/organization-dashboard-mock.svg" alt="조직과 팀별 역량 현황, 직무 및 업계 벤치마크, 교육 전후 변화와 Skill Gap을 보여주는 대시보드">
                    </div>

                    <ul class="product-points">
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-01-01" v-html="$rt('skills-analyze-item-point-01-01')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-01-02" v-html="$rt('skills-analyze-item-point-01-02')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-01-03" v-html="$rt('skills-analyze-item-point-01-03')"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="content-panel">
                <div class="content-panel__item">
                  <div class="content-panel__intro">
                    <p class="mini-title-sm" data-i18n="skills-analyze-item-label-02" v-html="$rt('skills-analyze-item-label-02')"></p>
                    <h3 data-i18n="skills-analyze-item-title-02" v-html="$rt('skills-analyze-item-title-02')"></h3>
                    <p class="desc-sm" data-i18n="skills-analyze-item-desc-02" v-html="$rt('skills-analyze-item-desc-02')"></p>
                  </div>
                  <div class="content-panel__visual">

                    <div class="performance-report-visual">
                      <img src="/images/mockups/performance-report-mock.svg" alt="교육 전후 역량 변화와 팀별 성과, 다음 투자 우선순위를 보여주는 교육 성과 보고서">
                    </div>

                    <ul class="product-points">
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-02-01" v-html="$rt('skills-analyze-item-point-02-01')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-02-02" v-html="$rt('skills-analyze-item-point-02-02')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-02-03" v-html="$rt('skills-analyze-item-point-02-03')"></span>
                      </li>
                      <li>
                        <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
                        <span data-i18n="skills-analyze-item-point-02-04" v-html="$rt('skills-analyze-item-point-02-04')"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="outcomes is-dark fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-outcomes-eyebrow" v-html="$rt('skills-outcomes-eyebrow')"></p>
          <h2 data-i18n="skills-outcomes-title" v-html="$rt('skills-outcomes-title')"></h2>
        </div>
        <div class="section-content">

          <ul class="start-grid" data-stat-reveal="" data-stat-card=".start-card">
            <li>
              <div class="content-panel content-panel--compact start-card">
                <span class="icon-box tint" aria-hidden="true">

                  <svg class="icon-md" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9C7.06087 9 8.07827 9.42142 8.82841 10.1716C9.57856 10.9217 10 11.9391 10 13V18C10 18.2652 9.89464 18.5196 9.70711 18.7071C9.51957 18.8946 9.26522 19 9 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V13C2 11.9391 2.42142 10.9217 3.17157 10.1716C3.92172 9.42142 4.93913 9 6 9Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M6 8C7.38071 8 8.5 6.88071 8.5 5.5C8.5 4.11929 7.38071 3 6 3C4.61929 3 3.5 4.11929 3.5 5.5C3.5 6.88071 4.61929 8 6 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M21 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1053 18.5196 14 18.2652 14 18V13C14 11.9391 14.4214 10.9217 15.1716 10.1716C15.9217 9.42142 16.9391 9 18 9C19.0609 9 20.0783 9.42142 20.8284 10.1716C21.5786 10.9217 22 11.9391 22 13V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3C16.6193 3 15.5 4.11929 15.5 5.5C15.5 6.88071 16.6193 8 18 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M11.1201 12H12.8701C13.931 12 14.9484 12.4214 15.6985 13.1716C16.4487 13.9217 16.8701 14.9391 16.8701 16V21C16.8701 21.2652 16.7648 21.5196 16.5772 21.7071C16.3897 21.8946 16.1353 22 15.8701 22H8.12012C7.8549 22 7.60055 21.8946 7.41301 21.7071C7.22547 21.5196 7.12012 21.2652 7.12012 21V16C7.12012 14.9391 7.54154 13.9217 8.29169 13.1716C9.04183 12.4214 10.0593 12 11.1201 12Z" fill="var(--color-brand)"></path>
                    <path d="M12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11Z" fill="var(--color-brand)"></path>
                  </svg>
                </span>
                <div class="content-panel__intro">
                  <p class="text-label metric-card__label" data-i18n="skills-outcomes-metric-label-01" v-html="$rt('skills-outcomes-metric-label-01')"></p>
                  <p class="metric-card__value"><span class="num" data-target="39355">0</span><span class="unit">명</span></p>
                </div>
              </div>
            </li>
            <li>
              <div class="content-panel content-panel--compact start-card">
                <span class="icon-box tint" aria-hidden="true">

                  <svg class="icon-md" viewBox="0 0 24 24" fill="none">
                    <path d="M19.5 4.01953H4.5C3.39543 4.01953 2.5 4.91496 2.5 6.01953V19.0195C2.5 20.1241 3.39543 21.0195 4.5 21.0195H19.5C20.6046 21.0195 21.5 20.1241 21.5 19.0195V6.01953C21.5 4.91496 20.6046 4.01953 19.5 4.01953Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M8.48001 3.01953H7.5C7.22386 3.01953 7 3.24339 7 3.51953V5.51953C7 5.79567 7.22386 6.01953 7.5 6.01953H8.48001C8.75615 6.01953 8.98001 5.79567 8.98001 5.51953V3.51953C8.98001 3.24339 8.75615 3.01953 8.48001 3.01953Z" fill="var(--color-brand)"></path>
                    <path d="M8.74023 9.5H7.24023C6.96409 9.5 6.74023 9.72386 6.74023 10V11.5C6.74023 11.7761 6.96409 12 7.24023 12H8.74023C9.01638 12 9.24023 11.7761 9.24023 11.5V10C9.24023 9.72386 9.01638 9.5 8.74023 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 9.5H11.25C10.9739 9.5 10.75 9.72386 10.75 10V11.5C10.75 11.7761 10.9739 12 11.25 12H12.75C13.0261 12 13.25 11.7761 13.25 11.5V10C13.25 9.72386 13.0261 9.5 12.75 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 9.5H15.2598C14.9836 9.5 14.7598 9.72386 14.7598 10V11.5C14.7598 11.7761 14.9836 12 15.2598 12H16.7598C17.0359 12 17.2598 11.7761 17.2598 11.5V10C17.2598 9.72386 17.0359 9.5 16.7598 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M16.5 3.01953H15.5C15.2239 3.01953 15 3.24339 15 3.51953V5.51953C15 5.79567 15.2239 6.01953 15.5 6.01953H16.5C16.7761 6.01953 17 5.79567 17 5.51953V3.51953C17 3.24339 16.7761 3.01953 16.5 3.01953Z" fill="var(--color-brand)"></path>
                    <path d="M8.74023 14H7.24023C6.96409 14 6.74023 14.2239 6.74023 14.5V16C6.74023 16.2761 6.96409 16.5 7.24023 16.5H8.74023C9.01638 16.5 9.24023 16.2761 9.24023 16V14.5C9.24023 14.2239 9.01638 14 8.74023 14Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 14H11.25C10.9739 14 10.75 14.2239 10.75 14.5V16C10.75 16.2761 10.9739 16.5 11.25 16.5H12.75C13.0261 16.5 13.25 16.2761 13.25 16V14.5C13.25 14.2239 13.0261 14 12.75 14Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 14H15.2598C14.9836 14 14.7598 14.2239 14.7598 14.5V16C14.7598 16.2761 14.9836 16.5 15.2598 16.5H16.7598C17.0359 16.5 17.2598 16.2761 17.2598 16V14.5C17.2598 14.2239 17.0359 14 16.7598 14Z" fill="var(--color-surface)"></path>
                  </svg>
                </span>
                <div class="content-panel__intro">
                  <p class="text-label metric-card__label" data-i18n="skills-outcomes-metric-label-02" v-html="$rt('skills-outcomes-metric-label-02')"></p>
                  <p class="metric-card__value"><span class="num" data-target="1531">0</span><span class="unit">회</span></p>
                </div>
              </div>
            </li>
            <li>
              <div class="content-panel content-panel--compact start-card">
                <span class="icon-box tint" aria-hidden="true">

                  <svg class="icon-md" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.08664 5.18651C8.22428 6.07383 7.35587 7.50805 6.75858 9.28963L6.75534 9.29929C5.74022 12.2473 5.75033 14.3788 6.11772 15.8818C6.18984 15.7847 6.26165 15.6862 6.33314 15.5865C7.83388 13.4927 9.07523 10.9908 9.82944 8.74653C10.623 6.31921 10.6115 5.03487 10.5026 4.44106C10.4907 4.37621 10.4777 4.31992 10.4645 4.27142C10.1684 4.33009 9.70398 4.55131 9.08664 5.18651ZM11.2029 3.09723L11.8891 2.05244L11.7624 1.96923L11.6195 1.91871C9.98554 1.34102 8.3982 2.30782 7.29384 3.44414C6.11755 4.65447 5.07902 6.43661 4.38988 8.49009C3.02832 12.4469 3.21132 15.4088 4.02481 17.5612C4.08858 17.7299 4.15588 17.8928 4.22613 18.0498C3.33593 18.8967 2.43613 19.5104 1.57178 19.8256L2.42827 22.1743C3.54636 21.7666 4.60958 21.0656 5.59562 20.1869C6.10788 20.7674 6.60902 21.1685 6.97368 21.4206L6.97688 21.4228C7.34507 21.6756 7.79536 21.7843 8.24179 21.7229C8.68768 21.6616 9.0901 21.4363 9.37611 21.0976L11.5982 18.4181L12.2452 20.4048C12.3375 20.6921 12.5045 20.9524 12.7324 21.1567C12.9624 21.3628 13.2454 21.5037 13.5523 21.5612C13.8596 21.6188 14.1761 21.59 14.4672 21.4788C14.758 21.3678 15.0104 21.1797 15.1998 20.9379L15.209 20.9261L16.9498 18.5896L17.5173 20.4432L17.5208 20.4545C17.6126 20.7444 17.7804 21.0072 18.01 21.213C18.24 21.4191 18.523 21.56 18.8299 21.6175C19.1372 21.6751 19.4537 21.6462 19.7448 21.5351C20.0356 21.424 20.288 21.236 20.4774 20.9941L20.4872 20.9816L23.0036 17.5931L20.9965 16.1026L19.4432 18.1942L18.8767 16.3438C18.7894 16.0479 18.6228 15.7783 18.391 15.5672C18.1551 15.3522 17.8615 15.2069 17.5431 15.1518C17.2243 15.0967 16.8973 15.1349 16.6008 15.2606C16.3126 15.3827 16.067 15.5813 15.8876 15.8309L14.1461 18.1683L13.528 16.2708C13.4401 15.9852 13.2778 15.7249 13.0543 15.5193C12.8239 15.3073 12.5381 15.1624 12.2276 15.1034C11.9169 15.0443 11.5961 15.0742 11.3017 15.1893C11.0196 15.2996 10.7753 15.4828 10.591 15.7162L7.89625 18.9658C7.72027 18.806 7.52855 18.6102 7.33578 18.3747C7.69445 17.9457 8.03806 17.4992 8.36509 17.0429C10.0189 14.7356 11.3717 12.0071 12.2009 9.53774L12.204 9.52848C13.0692 6.88392 13.1741 5.14821 12.9615 3.98983C12.8536 3.40202 12.6635 2.96213 12.4505 2.63929C12.3449 2.47931 12.2374 2.35369 12.1387 2.25679C12.0896 2.20854 12.0431 2.16793 12.0009 2.13408C11.9798 2.11717 11.9598 2.10199 11.9411 2.08841C11.9318 2.08163 11.9228 2.07525 11.9141 2.06926L11.9013 2.06056L11.8952 2.05643L11.8921 2.05442C11.8906 2.05342 11.8891 2.05244 11.2029 3.09723Z" fill="var(--color-brand)"></path>
                  </svg>
                </span>
                <div class="content-panel__intro">
                  <p class="text-label metric-card__label" data-i18n="skills-outcomes-metric-label-03" v-html="$rt('skills-outcomes-metric-label-03')"></p>
                  <p class="metric-card__value"><span class="num" data-target="80">0</span><span class="unit">%</span></p>
                </div>
              </div>
            </li>
            <li>
              <div class="content-panel content-panel--compact start-card">
                <span class="icon-box tint" aria-hidden="true">

                  <svg class="icon-md" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 8H8V21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21071 4.46957 8 5 8Z" fill="var(--color-brand)"></path>
                    <path d="M16.61 21H8V8H18.23C18.6805 8.00063 19.1252 8.10274 19.5308 8.29874C19.9365 8.49474 20.2928 8.77959 20.5734 9.13216C20.8539 9.48473 21.0514 9.89595 21.1512 10.3353C21.251 10.7746 21.2506 11.2308 21.15 11.67L19.54 18.67C19.3881 19.333 19.0154 19.9247 18.483 20.3481C17.9506 20.7714 17.2902 21.0013 16.61 21Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                    <path d="M14.11 1H14C13.681 0.999878 13.3666 1.07606 13.0831 1.22219C12.7995 1.36831 12.555 1.58014 12.37 1.84L8 8H13L15.74 4.16C15.953 3.86081 16.0795 3.50873 16.1057 3.14238C16.1318 2.77603 16.0566 2.40956 15.8882 2.08314C15.7199 1.75673 15.4649 1.48298 15.1512 1.29192C14.8375 1.10086 14.4773 0.999859 14.11 1Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                    <path d="M14 4H12V8H14V4Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                  </svg>
                </span>
                <div class="content-panel__intro">

                  <p class="text-label metric-card__label" data-i18n="skills-outcomes-metric-label-04" v-html="$rt('skills-outcomes-metric-label-04')"></p>
                  <p class="metric-card__value"><span class="num" data-target="4.5" data-decimals="1">0.0</span><span class="unit">/5</span></p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="faq fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skills-faq-eyebrow" v-html="$rt('skills-faq-eyebrow')"></p>
          <h2 data-i18n="skills-faq-title" v-html="$rt('skills-faq-title')"></h2>
        </div>
        <div class="section-content">
          <div class="faq-list">
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skills-faq-question-01" v-html="$rt('skills-faq-question-01')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skills-faq-answer-01" v-html="$rt('skills-faq-answer-01')"></p>
            </details>
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skills-faq-question-02" v-html="$rt('skills-faq-question-02')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skills-faq-answer-02" v-html="$rt('skills-faq-answer-02')"></p>
            </details>
            <details>
              <summary class="faq-list__question">
                <span data-i18n="skills-faq-question-03" v-html="$rt('skills-faq-question-03')"></span>
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer" data-i18n="skills-faq-answer-03" v-html="$rt('skills-faq-answer-03')"></p>
            </details>
          </div>
        </div>
      </div>
    </section>

    <section class="fade-up">
      <div class="section-wrap col">
        <div class="summary-banner dark">
          <div class="bridge-inner">
            <div class="bridge-copy">
              <h2 class="bridge-title" data-i18n="skills-bridge-title" v-html="$rt('skills-bridge-title')"></h2>
              <p class="bridge-desc" data-i18n="skills-bridge-desc" v-html="$rt('skills-bridge-desc')"></p>
            </div>
            <a class="btn btn-outline-inverse" href="/why-codepresso">
              <span data-i18n="skills-bridge-cta" v-html="$rt('skills-bridge-cta')"></span>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title" data-i18n="skills-cta-final-title" v-html="$rt('skills-cta-final-title')"></h2>
        <p class="cta-final-desc" data-i18n="skills-cta-final-desc" v-html="$rt('skills-cta-final-desc')"></p>
        <div class="cta-final-actions">
          <a href="https://codepresso.io/home/contact" class="btn btn-primary btn-lg">
            <span data-i18n="skills-cta-final-cta" v-html="$rt('skills-cta-final-cta')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
      </div>
    </section>

    <aside class="floating-cta" data-floating-cta="hero-diagnosis-cta" aria-label="AI 활용 진단 바로가기" hidden="">
      <button class="floating-cta-close" type="button" data-floating-cta-close="" aria-label="진단 배너 닫기">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>
      </button>
      <a class="floating-cta-link" href="https://ai-literacy.codepresso.io/">

        <span class="floating-cta-mock" aria-hidden="true">
          <span class="floating-cta-mock-question" data-i18n="skills-floating-mock-01" v-html="$rt('skills-floating-mock-01')"></span>
          <ul class="floating-cta-mock-levels">
            <li style="--mock-slot-index: 0">
              <span class="floating-cta-mock-emoji">🔍</span>
              <span class="floating-cta-mock-name" data-i18n="skills-floating-mock-02" v-html="$rt('skills-floating-mock-02')"></span>
            </li>
            <li style="--mock-slot-index: 1">
              <span class="floating-cta-mock-emoji">⚡</span>
              <span class="floating-cta-mock-name" data-i18n="skills-floating-mock-03" v-html="$rt('skills-floating-mock-03')"></span>
            </li>
            <li style="--mock-slot-index: 2">
              <span class="floating-cta-mock-emoji">📐</span>
              <span class="floating-cta-mock-name" data-i18n="skills-floating-mock-04" v-html="$rt('skills-floating-mock-04')"></span>
            </li>
            <li style="--mock-slot-index: 3">
              <span class="floating-cta-mock-emoji">🌟</span>
              <span class="floating-cta-mock-name" data-i18n="skills-floating-mock-05" v-html="$rt('skills-floating-mock-05')"></span>
            </li>
          </ul>
        </span>
        <span class="floating-cta-copy" data-i18n="skills-floating-cta-copy" v-html="$rt('skills-floating-cta-copy')"></span>
        <span class="floating-cta-action">
          <span data-i18n="skills-floating-cta-action" v-html="$rt('skills-floating-cta-action')"></span>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </span>
      </a>
    </aside>
  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/header-scroll.js","js/nav-menu.js","js/feature-card-cycle.js","js/journey-stage.js","js/stat-reveal.js","js/floating-cta.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Skills/ko.json'
import en from '../data/i18n-dist/Skills/en.json'
import ja from '../data/i18n-dist/Skills/ja.json'
import vi from '../data/i18n-dist/Skills/vi.json'
import es from '../data/i18n-dist/Skills/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
